/**
 * Evaluation System Constants
 * 
 * These constants define the default evaluation categories used as templates.
 * Custom categories are now supported by the pipeline.
 * NOTE: These are strictly for templating/defaults and are NOT enforced by the pipeline.
 */

export const DEFAULT_EVALUATION_CATEGORIES_TEMPLATE = [
  {
    name: 'Presentation Structure',
    description: 'Evaluation of the presentation organization, flow, and structure',
    required: false,
    order: 1,
    pipelineStatus: 'EVALUATING_STRUCTURE', // Legacy compatibility
    weight: 1.0,
    defaultCriteria: [
      {
        name: 'Opening and Introduction',
        description: 'Effectiveness of the presentation opening and personal introduction',
        scoringMethodology: 'Evaluate the clarity of introduction, engagement factor, and professional presence in the opening',
        weight: 1.0,
        ratingScale: { type: 'points', min: 1, max: 5, labels: { 1: 'Poor', 5: 'Excellent' } }
      },
      // ... other default structure criteria
    ]
  },
  // Other default templates can be added here
];

// For backward compatibility only - points to the template
export const FIXED_EVALUATION_CATEGORIES = DEFAULT_EVALUATION_CATEGORIES_TEMPLATE;

/**
 * Get the fixed category names as an array (Legacy helper)
 */
export const getFixedCategoryNames = () => {
  return DEFAULT_EVALUATION_CATEGORIES_TEMPLATE.map(category => category.name);
};

/**
 * Get a fixed category by name (Legacy helper)
 */
export const getFixedCategoryByName = (name: string) => {
  return DEFAULT_EVALUATION_CATEGORIES_TEMPLATE.find(category => category.name === name);
};

/**
 * Validate that the schema has valid structure (at least one category)
 * Note: Custom categories are now supported, so we no longer check against a fixed list.
 */
export const validateSchemaCategories = (schemaCategories: any[]) => {
  return {
    isValid: schemaCategories && schemaCategories.length > 0,
    missingCategories: [],
    extraCategories: []
  };
};